export const loginEndpoints = {
  login: { method: 'post', path: '/' },
  availableOrganisations: { method: 'get', path: '/available-organisations' },
} as const
